import { useState } from "react";
import { Paper, Typography, Button, Box } from "@mui/material";
import InvestmentInfoFields from "./InvestmentInfoFields";
import AddInvestmentForm from "../add-investment-modal";
import DateSelect from "../../../common/DateSelect";
import { InitialDateValues, createInitialDateValues } from "../../types";
import { useFormik, FormikProvider } from "formik";
import useInvestmentsListForClient from "../../hooks/useInvestmentsListForClient";
import { dateRangeValidation } from "../../../../shared/sharedFormSchema";
import { useClientDetails } from "../../context/clientDetailsContext";

const investmentsDateRange = dateRangeValidation("investment");
const initialDateValues = createInitialDateValues("investment");

function InvestmentsCard() {
  const [openModal, setOpenModal] = useState(false);
  const { clientId } = useClientDetails();

  const formik = useFormik<InitialDateValues<"investment">>({
    initialValues: initialDateValues,
    validationSchema: investmentsDateRange,
    onSubmit: () => {},
  });
  const { investments, loading, error, fetchInvestmentDetails } =
    useInvestmentsListForClient(
      clientId,
      formik.values["investment-start-date"],
      formik.values["investment-end-date"],
    );

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <>
      {openModal && (
        <AddInvestmentForm open={openModal} setOpen={setOpenModal} />
      )}
      <Paper elevation={3}>
        <Box
          id="investment-container"
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "32px",
          }}
        >
          <Box
            id="header-container"
            data-testid="investment-header-container"
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 2,
            }}
          >
            <Box id="title-container">
              <Typography
                data-testid="investment-info-title"
                align="left"
                variant="h5"
              >
                Investments
              </Typography>
            </Box>
          </Box>
          <FormikProvider value={formik}>
            <Box
              id="button-container"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 4,
              }}
            >
              <DateSelect
                dateName="investment"
                minDate={new Date("01/01/2018")}
              />
              <Button
                variant="contained"
                size="medium"
                data-testid="add-investment-modal-button"
                onClick={handleOpenModal}
              >
                Add Investment
              </Button>
            </Box>
            <Box id="investment-table-container" sx={{ display: "flex" }}>
              <InvestmentInfoFields
                investments={investments}
                loading={loading}
                error={error}
                fetchInvestmentDetails={fetchInvestmentDetails}
              />
            </Box>
          </FormikProvider>
        </Box>
      </Paper>
    </>
  );
}

export default InvestmentsCard;
